
import {onMounted, ref} from 'vue';
import {GetRecipesForProduct} from 'Apis/apis';
import Swiper, {Navigation} from 'swiper';
Swiper.use([Navigation]);

export default {
	name: 'RecipesMobile',
	setup() {
		const recipes = ref([]);
		const recipesLoading = ref(true);
		const fallbackImage = ref('/ResourcePackages/RoyalPrestige/assets/src/project/images/Misc/noimage.jpg');
		const translations = ref({});
		const mobileRecipes = ref(null);
		const prevButton = ref(null);
		const nextButton = ref(null);

		let productId = document.querySelector('.js-recipes').getAttribute('data-product-id') ? document.querySelector('.js-recipes').getAttribute('data-product-id') : "";

		let setupSwiper = () => {
			let mySwiper = new Swiper(mobileRecipes.value, {
				slidesPerView: 1,
				spaceBetween: 0,
				navigation: {
					nextEl: nextButton.value,
					prevEl: prevButton.value,
				}
			});
		};

		async function getRecipes(productId) {
			const rsp = await GetRecipesForProduct(productId);
			//preload images before assigning
			let promises = [];
			let thumbnailPromise;

			for (let [index, item] of rsp.value.entries()) {
				if(item.Image1.length) {
					thumbnailPromise = new Promise((resolve) => {
						let thumbnail = new Image();
						thumbnail.onload = resolve;
						thumbnail.src = item.Image1[0]?.Url;
					});
					promises.push(thumbnailPromise);
				}
			}

			// Wait for both promises to be resolved
			if (thumbnailPromise) {
				await Promise.all(promises);
			}
			//END Preload

			recipes.value = rsp?.value;
			setupSwiper();
			recipesLoading.value = false;
		}

		onMounted(() => {
			const translationEl = document.querySelector('.js-recipes');
			const translationValue = translationEl.getAttribute('data-translations');
			if (translationEl && translationValue) {
				translations.value = JSON.parse(translationValue);
			}
			getRecipes(productId);
		});

		return {
			recipes,
			productId,
			recipesLoading,
			fallbackImage,
			translations,
			mobileRecipes,
			nextButton,
			prevButton
		};
	},
};
